import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { EmulatedStreamingText } from '../../../../components/EmulatedStreamingText';

export const StyledLeadScoringAgentSummaryText = styled(EmulatedStreamingText)`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[300])}
`;
